
import React from 'react'
import { ArrowForward } from "@mui/icons-material"

import "./customicons.css"

export const ArrowForwardIconWhite = ({onClick }) => {

  return (
   
    <div>
      <ArrowForward className = "arrowForwardIconWhite" onClick = {onClick}/>
    
    </div> 

  )
}
  




